import {
  ErrorBoundary,
  PlanningActionType,
  PlanningWorkPackageSlider,
  WorkPackageItemCard,
  usePlanning,
} from '@bechtel/client-common';
import { WorkPackage } from '@bechtel/types';
import { includes } from 'lodash';
import { FC } from 'react';
import { WorkPackageItemContainer } from './styled';

interface ListItemProps {
  wp: WorkPackage;
  planningWorkPackageSlider: PlanningWorkPackageSlider;
}
export const ListItem: FC<ListItemProps> = ({ wp, planningWorkPackageSlider }) => {
  const { selectedWpList, planningDispatch } = usePlanning();
  const selected = includes(selectedWpList, wp.id);
  return (
    <WorkPackageItemContainer
      key={wp.id}
      data-testid={selected ? `workpackage-card-selected-list-${wp.id}` : `workpackage-card-unselected-list-${wp.id}`}
      onClick={() => {
        planningDispatch({
          type:
            planningWorkPackageSlider === PlanningWorkPackageSlider.Multiple
              ? PlanningActionType.MultiWorkPackageSelected
              : PlanningActionType.SingleWorkPackageSelected,
          payload: { selectedWpList: [wp.id] },
        });
      }}
      selected={selected}
      planningWorkPackageSlider={
        planningWorkPackageSlider ? planningWorkPackageSlider : PlanningWorkPackageSlider.Single
      }
    >
      <ErrorBoundary>
        <WorkPackageItemCard workPackage={wp} showOwnershipType={false} />
      </ErrorBoundary>
    </WorkPackageItemContainer>
  );
};
